document.addEventListener('DOMContentLoaded', function() {
  const galleryTriggers = document.querySelectorAll('[data-gallery-trigger]');
  const galleryPopup = document.getElementById('ayurvedagram-gallery-popup');
  const closeButtons = document.querySelectorAll('[data-gallery-close]');
  const prevButton = document.querySelector('[data-gallery-prev]');
  const nextButton = document.querySelector('[data-gallery-next]');
  const slides = document.querySelectorAll('.ayurvedagram-section__gallery-slide');
  const thumbnails = document.querySelectorAll('.ayurvedagram-section__gallery-thumbnail');
  const thumbnailsContainer = document.querySelector('.ayurvedagram-section__gallery-thumbnails');
  const thumbnailsPrev = document.querySelector('[data-thumbnails-prev]');
  const thumbnailsNext = document.querySelector('[data-thumbnails-next]');
  
  if (galleryTriggers.length === 0 || !galleryPopup) return;

  let currentSlideIndex = 0;
  let thumbnailScrollPosition = 0;

  // Open gallery popup - attach to all trigger buttons
  galleryTriggers.forEach(function(galleryTrigger) {
    galleryTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openGallery();
    });
  });

  // Close gallery popup
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      closeGallery();
    });
  });

  // Previous slide
  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      navigateSlide(-1);
    });
  }

  // Next slide
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      navigateSlide(1);
    });
  }

  // Thumbnail clicks
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      currentSlideIndex = index;
      updateSlideDisplay();
      scrollThumbnailToActive();
    });
  });

  // Thumbnail slider navigation
  if (thumbnailsPrev) {
    thumbnailsPrev.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollThumbnails(-1);
    });
  }

  if (thumbnailsNext) {
    thumbnailsNext.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollThumbnails(1);
    });
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (!galleryPopup || galleryPopup.getAttribute('aria-hidden') === 'true') return;

    if (e.key === 'Escape') {
      closeGallery();
    } else if (e.key === 'ArrowLeft') {
      navigateSlide(-1);
    } else if (e.key === 'ArrowRight') {
      navigateSlide(1);
    }
  });

  // Prevent body scroll when popup is open
  function preventBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  function allowBodyScroll() {
    document.body.style.overflow = '';
  }

  function openGallery() {
    if (!galleryPopup) return;
    galleryPopup.setAttribute('aria-hidden', 'false');
    currentSlideIndex = 0;
    thumbnailScrollPosition = 0;
    if (thumbnailsContainer) {
      thumbnailsContainer.scrollLeft = 0;
    }
    updateSlideDisplay();
    preventBodyScroll();
    // Update thumbnail nav buttons after a short delay to ensure layout is ready
    setTimeout(function() {
      updateThumbnailNavButtons();
    }, 100);
  }

  function closeGallery() {
    if (!galleryPopup) return;
    galleryPopup.setAttribute('aria-hidden', 'true');
    allowBodyScroll();
  }

  /**
   * Navigate to the next or previous slide
   * @param {number} direction - 1 for next, -1 for previous
   */
  function navigateSlide(direction) {
    if (slides.length === 0) return;

    currentSlideIndex += direction;

    if (currentSlideIndex < 0) {
      currentSlideIndex = slides.length - 1;
    } else if (currentSlideIndex >= slides.length) {
      currentSlideIndex = 0;
    }

    updateSlideDisplay();
  }

  function updateSlideDisplay() {
    slides.forEach((slide, index) => {
      if (index === currentSlideIndex) {
        slide.classList.add('ayurvedagram-section__gallery-slide--active');
      } else {
        slide.classList.remove('ayurvedagram-section__gallery-slide--active');
      }
    });

    // Update thumbnail active state
    thumbnails.forEach((thumbnail, index) => {
      if (index === currentSlideIndex) {
        thumbnail.classList.add('ayurvedagram-section__gallery-thumbnail--active');
      } else {
        thumbnail.classList.remove('ayurvedagram-section__gallery-thumbnail--active');
      }
    });

    // Update thumbnail navigation buttons
    updateThumbnailNavButtons();
  }

  function scrollThumbnails(direction) {
    if (!thumbnailsContainer) return;
    
    const thumbnailWidth = thumbnails[0] ? thumbnails[0].offsetWidth + 16 : 136; // width + gap
    const containerWidth = thumbnailsContainer.offsetWidth;
    const maxScroll = thumbnailsContainer.scrollWidth - containerWidth;
    
    thumbnailScrollPosition += direction * (thumbnailWidth * 2); // Scroll 2 thumbnails at a time
    
    if (thumbnailScrollPosition < 0) {
      thumbnailScrollPosition = 0;
    } else if (thumbnailScrollPosition > maxScroll) {
      thumbnailScrollPosition = maxScroll;
    }
    
    thumbnailsContainer.scrollTo({
      left: thumbnailScrollPosition,
      behavior: 'smooth'
    });
    
    updateThumbnailNavButtons();
  }

  function scrollThumbnailToActive() {
    if (!thumbnailsContainer || !thumbnails[currentSlideIndex]) return;
    
    const activeThumbnail = thumbnails[currentSlideIndex];
    const containerWidth = thumbnailsContainer.offsetWidth;
    const thumbnailWidth = activeThumbnail.offsetWidth + 16; // width + gap
    const thumbnailLeft = activeThumbnail.offsetLeft;
    const thumbnailCenter = thumbnailLeft + (thumbnailWidth / 2);
    const containerCenter = containerWidth / 2;
    
    thumbnailScrollPosition = thumbnailCenter - containerCenter;
    
    const maxScroll = thumbnailsContainer.scrollWidth - containerWidth;
    if (thumbnailScrollPosition < 0) {
      thumbnailScrollPosition = 0;
    } else if (thumbnailScrollPosition > maxScroll) {
      thumbnailScrollPosition = maxScroll;
    }
    
    thumbnailsContainer.scrollTo({
      left: thumbnailScrollPosition,
      behavior: 'smooth'
    });
    
    updateThumbnailNavButtons();
  }

  function updateThumbnailNavButtons() {
    if (!thumbnailsContainer || !thumbnailsPrev || !thumbnailsNext) return;
    
    const maxScroll = thumbnailsContainer.scrollWidth - thumbnailsContainer.offsetWidth;
    const currentScroll = thumbnailsContainer.scrollLeft;
    
    // Update prev button
    if (currentScroll <= 0) {
      thumbnailsPrev.disabled = true;
    } else {
      thumbnailsPrev.disabled = false;
    }
    
    // Update next button
    if (currentScroll >= maxScroll - 1) { // -1 for rounding errors
      thumbnailsNext.disabled = true;
    } else {
      thumbnailsNext.disabled = false;
    }
  }

  // Update buttons on scroll
  if (thumbnailsContainer) {
    thumbnailsContainer.addEventListener('scroll', function() {
      thumbnailScrollPosition = thumbnailsContainer.scrollLeft;
      updateThumbnailNavButtons();
    });
  }

  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  if (galleryPopup) {
    galleryPopup.addEventListener('touchstart', function(e) {
      if (e.changedTouches && e.changedTouches[0]) {
        touchStartX = e.changedTouches[0].screenX;
      }
    }, { passive: true });

    galleryPopup.addEventListener('touchend', function(e) {
      if (e.changedTouches && e.changedTouches[0]) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }
    }, { passive: true });
  }

  function handleSwipe() {
    if (!galleryPopup || galleryPopup.getAttribute('aria-hidden') === 'true') return;

    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        navigateSlide(1);
      } else {
        // Swipe right - previous slide
        navigateSlide(-1);
      }
    }
  }
});

